import { render, staticRenderFns } from "./paymenttochina-add.vue?vue&type=template&id=16f2e5cb&"
import script from "./paymenttochina-add.vue?vue&type=script&lang=js&"
export * from "./paymenttochina-add.vue?vue&type=script&lang=js&"
import style0 from "./paymenttochina-add.vue?vue&type=style&index=0&id=16f2e5cb&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports